// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chat Component Common Styles - All classes prefixed with chat_ */

.chat-scrollbar-transparent-track::-webkit-scrollbar-track {
  background: transparent;
}

.chat-scrollbar-transparent-track::-webkit-scrollbar-corner {
  background: transparent;
}

/* ============================================
   CARD STYLES
   ============================================ */
.chat_card {
  border-radius: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  transition: all 0.25s ease;
}

.chat_card_primary {
  border: 1px solid;
  border-color: rgba(59, 91, 219, 0.2);
  background-color: rgba(59, 91, 219, 0.1);
}

.dark .chat_card_primary {
  border-color: rgba(59, 91, 219, 0.51);
  background-color: rgba(15, 23, 42, 0.9);
}

.chat_card_secondary {
  border: 1px solid;
  border-color: rgba(40, 172, 168, 0.2);
  background-color: rgba(40, 172, 168, 0.1);
}

.dark .chat_card_secondary {
  border-color: rgba(40, 172, 168, 0.33);
  background-color: rgba(15, 23, 42, 0.9);
}

.chat_card_rounded_lg {
  border-radius: 16px;
}

.chat_card_rounded_xl {
  border-radius: 20px;
}

.chat_card_padding_sm {
  padding: 12px;
}

.chat_card_padding_md {
  padding: 16px;
}

.chat_card_padding_lg {
  padding: 20px;
}

/* ============================================
   GRADIENT BACKGROUNDS
   ============================================ */
.chat_gradient_bg {
  background: linear-gradient(135deg, var(--chat-primary-rgba, rgba(59, 91, 219, 0.15)) 0%, var(--chat-secondary-rgba, rgba(40, 172, 168, 0.15)) 100%);
}

.chat_gradient_bg_dark {
  background: linear-gradient(135deg, rgba(59, 91, 219, 0.2) 0%, rgba(40, 172, 168, 0.2) 100%);
}

.chat_gradient_bg_light {
  background: linear-gradient(135deg, rgba(59, 91, 219, 0.15) 0%, rgba(40, 172, 168, 0.15) 100%);
}

/* ============================================
   TYPOGRAPHY
   ============================================ */
.chat_heading_lg {
  font-size: 18px;
  line-height: 1.5;
  color: #111827;
  font-weight: 600; /* Semi-bold */
}

.chat_heading_md {
  font-size: 16px;
  line-height: 1.5;
  color: var(--chat-heading-color, #111827);
}

/* Common heading style for all chat section headings */
.chat_section_heading {
  font-size: 18px;
  font-weight: 600; /* Semi-bold */
  color: #111827;
  line-height: 1.5;
}

.dark .chat_section_heading {
  color: #F9FAFB;
}

.chat_heading_sm {
  font-size: 14px;
  line-height: 1.5;
  color: var(--chat-heading-color, #111827);
}

.chat_text_lg {
  font-size: 16px;
  line-height: 1.6;
}

.chat_text_md {
  font-size: 14px;
  line-height: 1.6;
}

.chat_text_sm {
  font-size: 12px;
  line-height: 1.5;
}

.chat_text_xs {
  font-size: 11px;
  line-height: 1.4;
}

/* Font Weights */
.chat_font_normal {
  font-weight: 400;
}

.chat_font_medium {
  font-weight: 500;
}

.chat_font_semibold {
  font-weight: 600;
}

.chat_font_bold {
  font-weight: 700;
}

/* Text Colors */
.chat_text_primary {
  color: #111827;
}

.chat_text_secondary {
  color: #495057;
}

.chat_text_muted {
  color: #868E96;
}

.chat_text_light {
  color: #E5E7EB;
}

.chat_text_dark {
  color: #212529;
}

.chat_text_white {
  color: #FFFFFF;
}

.chat_text_gray_500 {
  color: #6B7280;
}

.chat_text_gray_600 {
  color: #4B5563;
}

.chat_text_gray_900 {
  color: #111827;
}

.chat_text_job_title {
  color: #495057;
  font-size: 16px;
  line-height: 32px;
  letter-spacing: 0.5px;
}

.chat_text_sidebar_title {
  color: #212529;
  font-size: 16px;
}

.chat_text_sidebar_label {
  color: #868E96;
  font-size: 12px;
  font-weight: 500;
}

.chat_text_sidebar_active {
  color: #212529;
  font-size: 16px;
}

/* Dark mode text colors */
.dark .chat_text_primary {
  color: #F9FAFB;
}

.dark .chat_text_secondary {
  color: #D1D5DB;
}

.dark .chat_text_muted {
  color: #9CA3AF;
}

.dark .chat_text_dark {
  color: #E5E7EB;
}

.dark .chat_text_sidebar_title {
  color: #E9ECEF;
}

.dark .chat_text_sidebar_active {
  color: #F8F9FA;
}

.dark .chat_heading_lg,
.dark .chat_heading_md,
.dark .chat_heading_sm {
  color: #F9FAFB;
}

/* ============================================
   SPACING
   ============================================ */
.chat_spacing_xs {
  gap: 4px;
}

.chat_spacing_sm {
  gap: 8px;
}

.chat_spacing_md {
  gap: 16px;
}

.chat_spacing_lg {
  gap: 24px;
}

.chat_spacing_xl {
  gap: 32px;
}

.chat_mb_xs {
  margin-bottom: 4px;
}

.chat_mb_sm {
  margin-bottom: 8px;
}

.chat_mb_md {
  margin-bottom: 12px;
}

.chat_mb_lg {
  margin-bottom: 24px;
}

.chat_mt_sm {
  margin-top: 8px;
}

.chat_mt_md {
  margin-top: 16px;
}

.chat_mt_lg {
  margin-top: 24px;
}

.chat_mt_xs {
  margin-top: 4px;
}

.chat_gap_sm {
  gap: 8px;
}

.chat_gap_md {
  gap: 16px;
}

.chat_gap_lg {
  gap: 24px;
}

/* ============================================
   MESSAGE STYLES
   ============================================ */
.chat_message_container {
  max-width: 75%;
  border-radius: 16px;
  padding: 12px 16px;
  overflow: hidden;
  word-break: break-word;
  overflow-wrap: break-word;
}

/* On small screens, allow messages to take more width */
@media (max-width: 640px) {
  .chat_message_container {
    max-width: 88%;
  }
}

.chat_message_user {
  background-color: #E5E7EB;
  color: #111827;
}

.dark .chat_message_user {
  background-color: #374151;
  color: #F9FAFB;
}

.chat_message_agent {
  background: linear-gradient(135deg, #E2E8FF 0%, #E6FFF7 100%);
  color: #111827;
}

.dark .chat_message_agent {
  background: linear-gradient(135deg, #1e5f7f 0%, #1a6b5e 100%);
  color: #E5E7EB;
}

/* Ask-mode message bubble — same styling as agent bubble */
.chat_message_ask {
  background: linear-gradient(135deg, #E2E8FF 0%, #E6FFF7 100%);
  color: #111827;
}

.dark .chat_message_ask {
  background: linear-gradient(135deg, #1e5f7f 0%, #1a6b5e 100%);
  color: #E5E7EB;
}

/* Mode toggle buttons */
.chat-mode-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  border: 1px solid transparent;
  line-height: 1;
}

.chat-mode-toggle-active {
  background: linear-gradient(135deg, #E2E8FF 0%, #E6FFF7 100%);
  color: #3B5BDB;
  border-color: #3B5BDB40;
}

.dark .chat-mode-toggle-active {
  background: linear-gradient(135deg, #1e3a5f 0%, #1a4b3e 100%);
  color: #93C5FD;
  border-color: #3B82F640;
}

.chat-mode-toggle-active-ask {
  background: linear-gradient(135deg, #E2E8FF 0%, #E6FFF7 100%);
  color: #3B5BDB;
  border-color: #3B5BDB40;
}

.dark .chat-mode-toggle-active-ask {
  background: linear-gradient(135deg, #1e3a5f 0%, #1a4b3e 100%);
  color: #93C5FD;
  border-color: #3B82F640;
}

.chat-mode-toggle-inactive {
  background: transparent;
  color: #9CA3AF;
  border-color: transparent;
}

.chat-mode-toggle-inactive:hover {
  background: #F3F4F6;
  color: #6B7280;
}

.dark .chat-mode-toggle-inactive:hover {
  background: #374151;
  color: #D1D5DB;
}

/* Mode hint text */
.chat-mode-hint {
  font-size: 0.65rem;
  color: #9CA3AF;
  margin-left: 8px;
  line-height: 1;
}

.dark .chat-mode-hint {
  color: #6B7280;
}

/* Mode badge on messages — small, subtle label */
.chat-mode-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.6rem;
  font-weight: 500;
  padding: 0px 0px;
  line-height: 1.2;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  opacity: 0.7;
}

.chat-mode-badge-agent {
  color: #3B82F6;
}

.dark .chat-mode-badge-agent {
  color: #93C5FD;
}

.chat-mode-badge-ask {
  color: #059669;
}

.dark .chat-mode-badge-ask {
  color: #6EE7B7;
}

/* Retry as other mode button */
.chat-mode-retry {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 0.6rem;
  color: #9CA3AF;
  cursor: pointer;
  padding: 1px 4px;
  border-radius: 3px;
  border: none;
  background: none;
  transition: all 0.15s ease;
}

.chat-mode-retry:hover {
  color: #6B7280;
  background: #F3F4F6;
}

.dark .chat-mode-retry:hover {
  color: #D1D5DB;
  background: #374151;
}

.chat_loader_pill {
  border-radius: 9999px;
  padding: 4px 16px;
  background: linear-gradient(135deg, rgba(59, 91, 219, 0.15) 0%, rgba(32, 201, 151, 0.15) 100%);
  color: #111827;
}

.dark .chat_loader_pill {
  background: linear-gradient(135deg, rgba(59, 91, 219, 0.2) 0%, rgba(32, 201, 151, 0.2) 100%);
  color: #E5E7EB;
}

/* ============================================
   STATUS COLORS
   ============================================ */
.chat_status_completed {
  color: #2F9E44;
}

.chat_status_progress {
  color: #F08C00;
}

.chat_status_queued {
  color: #868E96;
}

/* ============================================
   LAYOUT
   ============================================ */
.chat_flex_col {
  display: flex;
  flex-direction: column;
}

.chat_flex_row {
  display: flex;
  flex-direction: row;
}

.chat_flex_1 {
  flex: 1 1;
}

.chat_grid_2col {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

@media (max-width: 768px) {
  .chat_grid_2col {
    grid-template-columns: 1fr;
  }
}

/* ============================================
   UTILITIES
   ============================================ */
.chat_no_shadow {
  box-shadow: none !important;
}

input.chat-sidebar-search-input,
input.chat-sidebar-search-input:focus,
input.chat-sidebar-search-input:focus-visible,
input.chat-sidebar-search-input[placeholder*="Search" i],
input.chat-sidebar-search-input[placeholder*="Search" i]:focus,
input.chat-sidebar-search-input[placeholder*="Search" i]:focus-visible {
  min-height: 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  outline: none !important;
}

.chat_transition {
  transition: all 0.25s ease;
}

.chat_rounded_full {
  border-radius: 9999px;
}

.chat_rounded_lg {
  border-radius: 12px;
}

.chat_rounded_xl {
  border-radius: 16px;
}

.chat_px_md {
  padding-left: 16px;
  padding-right: 16px;
}

.chat_py_sm {
  padding-top: 8px;
  padding-bottom: 8px;
}

.chat_rounded_lg {
  border-radius: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/chat.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;iDAEiD;AACjD;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;iDAEiD;AACjD;EACE,oJAAoJ;AACtJ;;AAEA;EACE,4FAA4F;AAC9F;;AAEA;EACE,8FAA8F;AAChG;;AAEA;;iDAEiD;AACjD;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB,EAAE,cAAc;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,gBAAgB,EAAE,cAAc;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;;iDAEiD;AACjD;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,8FAA8F;EAC9F,cAAc;AAChB;;AAEA;EACE,4FAA4F;EAC5F,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;iDAEiD;AACjD;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;iDAEiD;AACjD;EACE,2BAA2B;AAC7B;;AAEA;;;;;;EAME,wBAAwB;EACxB,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;EAClC,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Chat Component Common Styles - All classes prefixed with chat_ */\n\n.chat-scrollbar-transparent-track::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.chat-scrollbar-transparent-track::-webkit-scrollbar-corner {\n  background: transparent;\n}\n\n/* ============================================\n   CARD STYLES\n   ============================================ */\n.chat_card {\n  border-radius: 16px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  transition: all 0.25s ease;\n}\n\n.chat_card_primary {\n  border: 1px solid;\n  border-color: rgba(59, 91, 219, 0.2);\n  background-color: rgba(59, 91, 219, 0.1);\n}\n\n.dark .chat_card_primary {\n  border-color: rgba(59, 91, 219, 0.51);\n  background-color: rgba(15, 23, 42, 0.9);\n}\n\n.chat_card_secondary {\n  border: 1px solid;\n  border-color: rgba(40, 172, 168, 0.2);\n  background-color: rgba(40, 172, 168, 0.1);\n}\n\n.dark .chat_card_secondary {\n  border-color: rgba(40, 172, 168, 0.33);\n  background-color: rgba(15, 23, 42, 0.9);\n}\n\n.chat_card_rounded_lg {\n  border-radius: 16px;\n}\n\n.chat_card_rounded_xl {\n  border-radius: 20px;\n}\n\n.chat_card_padding_sm {\n  padding: 12px;\n}\n\n.chat_card_padding_md {\n  padding: 16px;\n}\n\n.chat_card_padding_lg {\n  padding: 20px;\n}\n\n/* ============================================\n   GRADIENT BACKGROUNDS\n   ============================================ */\n.chat_gradient_bg {\n  background: linear-gradient(135deg, var(--chat-primary-rgba, rgba(59, 91, 219, 0.15)) 0%, var(--chat-secondary-rgba, rgba(40, 172, 168, 0.15)) 100%);\n}\n\n.chat_gradient_bg_dark {\n  background: linear-gradient(135deg, rgba(59, 91, 219, 0.2) 0%, rgba(40, 172, 168, 0.2) 100%);\n}\n\n.chat_gradient_bg_light {\n  background: linear-gradient(135deg, rgba(59, 91, 219, 0.15) 0%, rgba(40, 172, 168, 0.15) 100%);\n}\n\n/* ============================================\n   TYPOGRAPHY\n   ============================================ */\n.chat_heading_lg {\n  font-size: 18px;\n  line-height: 1.5;\n  color: #111827;\n  font-weight: 600; /* Semi-bold */\n}\n\n.chat_heading_md {\n  font-size: 16px;\n  line-height: 1.5;\n  color: var(--chat-heading-color, #111827);\n}\n\n/* Common heading style for all chat section headings */\n.chat_section_heading {\n  font-size: 18px;\n  font-weight: 600; /* Semi-bold */\n  color: #111827;\n  line-height: 1.5;\n}\n\n.dark .chat_section_heading {\n  color: #F9FAFB;\n}\n\n.chat_heading_sm {\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--chat-heading-color, #111827);\n}\n\n.chat_text_lg {\n  font-size: 16px;\n  line-height: 1.6;\n}\n\n.chat_text_md {\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.chat_text_sm {\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.chat_text_xs {\n  font-size: 11px;\n  line-height: 1.4;\n}\n\n/* Font Weights */\n.chat_font_normal {\n  font-weight: 400;\n}\n\n.chat_font_medium {\n  font-weight: 500;\n}\n\n.chat_font_semibold {\n  font-weight: 600;\n}\n\n.chat_font_bold {\n  font-weight: 700;\n}\n\n/* Text Colors */\n.chat_text_primary {\n  color: #111827;\n}\n\n.chat_text_secondary {\n  color: #495057;\n}\n\n.chat_text_muted {\n  color: #868E96;\n}\n\n.chat_text_light {\n  color: #E5E7EB;\n}\n\n.chat_text_dark {\n  color: #212529;\n}\n\n.chat_text_white {\n  color: #FFFFFF;\n}\n\n.chat_text_gray_500 {\n  color: #6B7280;\n}\n\n.chat_text_gray_600 {\n  color: #4B5563;\n}\n\n.chat_text_gray_900 {\n  color: #111827;\n}\n\n.chat_text_job_title {\n  color: #495057;\n  font-size: 16px;\n  line-height: 32px;\n  letter-spacing: 0.5px;\n}\n\n.chat_text_sidebar_title {\n  color: #212529;\n  font-size: 16px;\n}\n\n.chat_text_sidebar_label {\n  color: #868E96;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.chat_text_sidebar_active {\n  color: #212529;\n  font-size: 16px;\n}\n\n/* Dark mode text colors */\n.dark .chat_text_primary {\n  color: #F9FAFB;\n}\n\n.dark .chat_text_secondary {\n  color: #D1D5DB;\n}\n\n.dark .chat_text_muted {\n  color: #9CA3AF;\n}\n\n.dark .chat_text_dark {\n  color: #E5E7EB;\n}\n\n.dark .chat_text_sidebar_title {\n  color: #E9ECEF;\n}\n\n.dark .chat_text_sidebar_active {\n  color: #F8F9FA;\n}\n\n.dark .chat_heading_lg,\n.dark .chat_heading_md,\n.dark .chat_heading_sm {\n  color: #F9FAFB;\n}\n\n/* ============================================\n   SPACING\n   ============================================ */\n.chat_spacing_xs {\n  gap: 4px;\n}\n\n.chat_spacing_sm {\n  gap: 8px;\n}\n\n.chat_spacing_md {\n  gap: 16px;\n}\n\n.chat_spacing_lg {\n  gap: 24px;\n}\n\n.chat_spacing_xl {\n  gap: 32px;\n}\n\n.chat_mb_xs {\n  margin-bottom: 4px;\n}\n\n.chat_mb_sm {\n  margin-bottom: 8px;\n}\n\n.chat_mb_md {\n  margin-bottom: 12px;\n}\n\n.chat_mb_lg {\n  margin-bottom: 24px;\n}\n\n.chat_mt_sm {\n  margin-top: 8px;\n}\n\n.chat_mt_md {\n  margin-top: 16px;\n}\n\n.chat_mt_lg {\n  margin-top: 24px;\n}\n\n.chat_mt_xs {\n  margin-top: 4px;\n}\n\n.chat_gap_sm {\n  gap: 8px;\n}\n\n.chat_gap_md {\n  gap: 16px;\n}\n\n.chat_gap_lg {\n  gap: 24px;\n}\n\n/* ============================================\n   MESSAGE STYLES\n   ============================================ */\n.chat_message_container {\n  max-width: 75%;\n  border-radius: 16px;\n  padding: 12px 16px;\n  overflow: hidden;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n\n/* On small screens, allow messages to take more width */\n@media (max-width: 640px) {\n  .chat_message_container {\n    max-width: 88%;\n  }\n}\n\n.chat_message_user {\n  background-color: #E5E7EB;\n  color: #111827;\n}\n\n.dark .chat_message_user {\n  background-color: #374151;\n  color: #F9FAFB;\n}\n\n.chat_message_agent {\n  background: linear-gradient(135deg, #E2E8FF 0%, #E6FFF7 100%);\n  color: #111827;\n}\n\n.dark .chat_message_agent {\n  background: linear-gradient(135deg, #1e5f7f 0%, #1a6b5e 100%);\n  color: #E5E7EB;\n}\n\n/* Ask-mode message bubble — same styling as agent bubble */\n.chat_message_ask {\n  background: linear-gradient(135deg, #E2E8FF 0%, #E6FFF7 100%);\n  color: #111827;\n}\n\n.dark .chat_message_ask {\n  background: linear-gradient(135deg, #1e5f7f 0%, #1a6b5e 100%);\n  color: #E5E7EB;\n}\n\n/* Mode toggle buttons */\n.chat-mode-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  border: 1px solid transparent;\n  line-height: 1;\n}\n\n.chat-mode-toggle-active {\n  background: linear-gradient(135deg, #E2E8FF 0%, #E6FFF7 100%);\n  color: #3B5BDB;\n  border-color: #3B5BDB40;\n}\n\n.dark .chat-mode-toggle-active {\n  background: linear-gradient(135deg, #1e3a5f 0%, #1a4b3e 100%);\n  color: #93C5FD;\n  border-color: #3B82F640;\n}\n\n.chat-mode-toggle-active-ask {\n  background: linear-gradient(135deg, #E2E8FF 0%, #E6FFF7 100%);\n  color: #3B5BDB;\n  border-color: #3B5BDB40;\n}\n\n.dark .chat-mode-toggle-active-ask {\n  background: linear-gradient(135deg, #1e3a5f 0%, #1a4b3e 100%);\n  color: #93C5FD;\n  border-color: #3B82F640;\n}\n\n.chat-mode-toggle-inactive {\n  background: transparent;\n  color: #9CA3AF;\n  border-color: transparent;\n}\n\n.chat-mode-toggle-inactive:hover {\n  background: #F3F4F6;\n  color: #6B7280;\n}\n\n.dark .chat-mode-toggle-inactive:hover {\n  background: #374151;\n  color: #D1D5DB;\n}\n\n/* Mode hint text */\n.chat-mode-hint {\n  font-size: 0.65rem;\n  color: #9CA3AF;\n  margin-left: 8px;\n  line-height: 1;\n}\n\n.dark .chat-mode-hint {\n  color: #6B7280;\n}\n\n/* Mode badge on messages — small, subtle label */\n.chat-mode-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 0.6rem;\n  font-weight: 500;\n  padding: 0px 0px;\n  line-height: 1.2;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  opacity: 0.7;\n}\n\n.chat-mode-badge-agent {\n  color: #3B82F6;\n}\n\n.dark .chat-mode-badge-agent {\n  color: #93C5FD;\n}\n\n.chat-mode-badge-ask {\n  color: #059669;\n}\n\n.dark .chat-mode-badge-ask {\n  color: #6EE7B7;\n}\n\n/* Retry as other mode button */\n.chat-mode-retry {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 0.6rem;\n  color: #9CA3AF;\n  cursor: pointer;\n  padding: 1px 4px;\n  border-radius: 3px;\n  border: none;\n  background: none;\n  transition: all 0.15s ease;\n}\n\n.chat-mode-retry:hover {\n  color: #6B7280;\n  background: #F3F4F6;\n}\n\n.dark .chat-mode-retry:hover {\n  color: #D1D5DB;\n  background: #374151;\n}\n\n.chat_loader_pill {\n  border-radius: 9999px;\n  padding: 4px 16px;\n  background: linear-gradient(135deg, rgba(59, 91, 219, 0.15) 0%, rgba(32, 201, 151, 0.15) 100%);\n  color: #111827;\n}\n\n.dark .chat_loader_pill {\n  background: linear-gradient(135deg, rgba(59, 91, 219, 0.2) 0%, rgba(32, 201, 151, 0.2) 100%);\n  color: #E5E7EB;\n}\n\n/* ============================================\n   STATUS COLORS\n   ============================================ */\n.chat_status_completed {\n  color: #2F9E44;\n}\n\n.chat_status_progress {\n  color: #F08C00;\n}\n\n.chat_status_queued {\n  color: #868E96;\n}\n\n/* ============================================\n   LAYOUT\n   ============================================ */\n.chat_flex_col {\n  display: flex;\n  flex-direction: column;\n}\n\n.chat_flex_row {\n  display: flex;\n  flex-direction: row;\n}\n\n.chat_flex_1 {\n  flex: 1;\n}\n\n.chat_grid_2col {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n}\n\n@media (max-width: 768px) {\n  .chat_grid_2col {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ============================================\n   UTILITIES\n   ============================================ */\n.chat_no_shadow {\n  box-shadow: none !important;\n}\n\ninput.chat-sidebar-search-input,\ninput.chat-sidebar-search-input:focus,\ninput.chat-sidebar-search-input:focus-visible,\ninput.chat-sidebar-search-input[placeholder*=\"Search\" i],\ninput.chat-sidebar-search-input[placeholder*=\"Search\" i]:focus,\ninput.chat-sidebar-search-input[placeholder*=\"Search\" i]:focus-visible {\n  min-height: 0 !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.chat_transition {\n  transition: all 0.25s ease;\n}\n\n.chat_rounded_full {\n  border-radius: 9999px;\n}\n\n.chat_rounded_lg {\n  border-radius: 12px;\n}\n\n.chat_rounded_xl {\n  border-radius: 16px;\n}\n\n.chat_px_md {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n.chat_py_sm {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.chat_rounded_lg {\n  border-radius: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
